/**
 * logs.service.ts — Layer 3: Diagnostics & Logs Domain
 */

import { getRequest, deleteWithBodyRequest } from './http.service';
import { URL_LOGS } from './url.service';

/** Get a page of logs matching a caller-built query string (filters/pagination) */
export const fetchLogs = (qs: string) =>
  getRequest(`${URL_LOGS}?${qs}`);

/** Delete logs by ID */
export const deleteLogs = (ids: string[]) =>
  deleteWithBodyRequest(URL_LOGS, { ids });
